import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const initialState = {
  hipaaSafePracticeName: "",
  paymentDetails: {
    amount: "0.00",
    merchantKey: "",
    practiceName: "",
    reason: "",
    requestDate: "",
    status: "OK",
    invalidState: "",
    amountPaid: "0.00", // What the patient paid
    preventPartial: false,
    termsAndConditionsLink: "",
    updoxPatientTermsOfServiceUrl: "",
    updoxPatientPrivacyLink: "",
  },
  maxVerificationAttempts: 3,
  remainingVerificationAttempts: 0,
};

const mutations = {
  setHipaaSafePracticeName(state, hipaaSafePracticeName) {
    state.hipaaSafePracticeName = hipaaSafePracticeName;
  },
  setPaymentDetails(state, paymentDetails) {
    state.paymentDetails = paymentDetails;
  },
  setPaymentRequestDate(state, paymentRequestDate) {
    state.paymentDetails.requestDate = paymentRequestDate;
  },
  setPaymentStatus(state, paymentStatus) {
    state.paymentDetails.status = paymentStatus;
  },
  setPaymentInvalidState(state, invalidState) {
    state.paymentDetails.invalidState = invalidState;
  },
  setCreditCardSaleResponse(state, creditCardSaleResponse) {
    state.paymentDetails.creditCardSaleResponse = creditCardSaleResponse;
  },
  setTermsAndConditionsLink(state, termsAndConditionsLink) {
    state.paymentDetails.termsAndConditionsLink = termsAndConditionsLink;
  },
  setUpdoxPatientTermsOfServiceUrl(state, updoxPatientTermsOfServiceUrl) {
    state.paymentDetails.updoxPatientTermsOfServiceUrl =
      updoxPatientTermsOfServiceUrl;
  },
  setUpdoxPatientPrivacyLink(state, updoxPatientPrivacyLink) {
    state.paymentDetails.updoxPatientPrivacyLink = updoxPatientPrivacyLink;
  },
  setRemainingVerificationAttempts(state, remainingVerificationAttempts) {
    state.remainingVerificationAttempts = remainingVerificationAttempts;
  },
};

const actions = {};

const getters = {
  hipaaSafePracticeName(state) {
    return state.hipaaSafePracticeName;
  },
  practiceName(state) {
    return state.paymentDetails.practiceName;
  },
  paymentDetails(state) {
    return state.paymentDetails;
  },
  paymentAmount(state) {
    return state.paymentDetails.amount;
  },
  preventPartial(state) {
    return state.paymentDetails.preventPartial;
  },
  minAmount(state) {
    return state.paymentDetails.minAmount;
  },
  termsAndConditionsLink(state) {
    return state.paymentDetails.termsAndConditionsLink;
  },
  updoxPatientTermsOfServiceUrl(state) {
    return state.paymentDetails.updoxPatientTermsOfServiceUrl;
  },
  updoxPatientPrivacyLink(state) {
    return state.paymentDetails.updoxPatientPrivacyLink;
  },
  paymentRequestDate(state) {
    return state.paymentDetails.requestDate;
  },
  paymentCreditCardSaleResponse(state) {
    return state.paymentDetails.creditCardSaleResponse;
  },
  merchantKey(state) {
    return state.paymentDetails.merchantKey;
  },
  remainingVerificationAttempts(state) {
    return state.remainingVerificationAttempts;
  },
  maxVerificationAttempts(state) {
    return state.maxVerificationAttempts;
  },
};

const modules = {};

export default new Vuex.Store({
  state: initialState,
  mutations,
  actions,
  modules,
  getters,
});
